var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.href ? 'a' : 'button',{tag:"component",class:[
    _vm.href
      ? [
          // Reset <a>
          'no-underline' ]
      : [
          // Reset <button>
          'select-none',
          'border-none',
          'bg-transparent' ],
    // Cursor
    'cursor-pointer',
    'hover-hover:disabled:cursor-not-allowed',
    // Override kit.scss styles
    'font-sans' ],attrs:{"href":_vm.href,"rel":_vm.href && 'noopener nofollow'},on:{"click":_vm.click,"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.handleSpaceKey($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }